import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { faturaResponsavelColumns } from './columns/_columns'
import { FaturaList } from '../../faturas-list/core/_models'
import { FaturaResponsavelExpandedRow } from './columns/FaturaResponsavelExpandedRow'
import { useT } from '_metronic/i18n/Metronici18n'

export const FaturaResponsavelTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => faturaResponsavelColumns(t), [t])

  // Sem instituição não há o que listar; com filtros e sem resultado, oferece limpar.
  const emptyState = !filters.empresa ? (
    <TableEmptyState
      title={`Selecione uma ${t('empresa.label.lowercase')}`}
      description={`As faturas são listadas por ${t(
        'empresa.label.lowercase'
      )}. Escolha uma no filtro acima.`}
    />
  ) : filters.mes || filters.ano || filters.situacao ? (
    <TableEmptyState
      title='Nenhuma fatura encontrada'
      description='Revise o período ou a situação.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma fatura ainda'
      description={`As faturas desta ${t(
        'empresa.label.lowercase'
      )} aparecem aqui quando forem geradas.`}
    />
  )

  return (
    <CustomTable<FaturaList>
      id='kt_table_faturas_responsavel'
      ariaLabel={t('fatura.plural')}
      itemLabel={{ singular: 'fatura', plural: 'faturas' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      enableExpand
      onExpandFetch={async (row) => row.original}
      getExpandLabel={(row) => {
        const { mesSigla, ano } = row.mesAno ?? {}
        return mesSigla && ano ? `fatura de ${mesSigla}/${ano}` : `fatura ${row.id}`
      }}
      renderExpand={(data: FaturaList, loading) => (
        <FaturaResponsavelExpandedRow data={data} isLoading={loading} />
      )}
    />
  )
}
